import { TranslationProvider } from "wonder-image";

export default class ApiClient {

    constructor(baseUrl, token) {

        this.baseUrl = baseUrl;
        this.token = token;

    }

    async request(endpoint, options = {}) {

        const headers = {
            "Authorization": `Bearer ${this.token}`,
            "Accept-Language": TranslationProvider.lang,
            ...options.headers,
        };

        // Se non è FormData, impostiamo JSON
        let body = options.body;

        if (!(body instanceof FormData) && body !== undefined) {
            headers["Content-Type"] = "application/json";
            body = JSON.stringify(body);
        }

        const response = await fetch(`${this.baseUrl}${endpoint}`, {
            ...options,
            headers,
            body
        });

        let data;
        const ct = response.headers.get("content-type") || "";

        try {
            data = await response.json();
        } catch {
            throw {
                success: false,
                status: response.status,
                response: "Errore nel parsing della risposta"
            };
        }
        
        if (!data.success) {
            throw data;
        }

        return data;

    }

    get(endpoint) {
        return this.request(endpoint, { method: "GET" });
    }

    post(endpoint, body) {
        return this.request(endpoint, { method: "POST", body });
    }

    put(endpoint, body) {
        return this.request(endpoint, { method: "PUT", body });
    }

    delete(endpoint) {
        return this.request(endpoint, { method: "DELETE" });
    }

}